import _ from 'lodash';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import typeActions from 'redux/typeActions';
import ServiceURL from 'services/ServiceURL';
import { DELETE, GET, POST, PUT } from 'services/ServiceBase';

export function* getBills(data) {
  const url = `${ServiceURL.bill}?filters[$and][0][deleted][$eq]=false&sort=createdAt:DESC&${data.query}`;
  const callback = data.callback;
  try {
    const res = yield call(GET, url);
    if (!!res.data?.error?.message) {
      yield put({
        type: typeActions.GET_BILLS_FAILED,
        error: res.data?.error?.message,
      });
      !!callback?.failed && callback.failed(res.data.error.message);
    } else {
      if (data.isUpdateReducer) {
        yield put({
          type: typeActions.GET_BILLS_SUCCESS,
          data: res.data,
        });
      }
      !!callback?.success && callback.success(res.data);
    }
  } catch (error) {
    yield put({
      type: typeActions.GET_BILLS_FAILED,
      error: error?.response?.data?.error?.message ?? '',
    });
    !!callback?.failed &&
      callback.failed(error?.response?.data?.error?.message ?? '');
  }
}

export function* getBill(data) {
  const url = `${ServiceURL.bill}/${data.param}?${data.query}`;
  const callback = data.callback;
  try {
    const res = yield call(GET, url);
    if (!!res.data?.error?.message) {
      yield put({
        type: typeActions.GET_BILL_FAILED,
        error: res.data.error.message,
      });
      !!callback?.failed && callback.failed(res.data.error.message);
    } else {
      yield put({
        type: typeActions.GET_BILL_SUCCESS,
        data: res.data,
      });
      !!callback?.success && callback.success(res.data);
    }
  } catch (error) {
    yield put({
      type: typeActions.GET_BILL_FAILED,
      error: error?.response?.data?.error?.message ?? '',
    });
    !!callback?.failed &&
      callback.failed(error?.response?.data?.error?.message ?? '');
  }
}

export function* createBill(data) {
  const url = `${ServiceURL.bill}`;
  const callback = data.callback;
  try {
    const res = yield call(POST, url, data.body);
    if (!!res.data?.error?.message) {
      yield put({
        type: typeActions.CREATE_BILL_FAILED,
        error: res.data.error.message,
      });
      !!callback?.failed && callback.failed(res.data.error.message);
    } else {
      yield put({
        type: typeActions.CREATE_BILL_SUCCESS,
        data: res.data?.data,
      });
      !!callback?.success && callback.success(res.data?.data);
    }
  } catch (error) {
    yield put({
      type: typeActions.CREATE_BILL_FAILED,
      error: error?.response?.data?.error?.message ?? '',
    });
    !!callback?.failed &&
      callback.failed(error?.response?.data?.error?.message ?? '');
  }
}

export function* updateBill(data) {
  const url = `${ServiceURL.bill}/${data.param}`;
  const callback = data.callback;
  try {
    const res = yield call(PUT, url, data.body);
    if (!!res.data?.error?.message) {
      yield put({
        type: typeActions.UPDATE_BILL_FAILED,
        error: res.data.error.message,
      });
      !!callback?.failed && callback.failed(res.data.error.message);
    } else {
      yield put({
        type: typeActions.UPDATE_BILL_SUCCESS,
        data: res.data,
      });

      !!callback?.success && callback.success(res.data);
    }
  } catch (error) {
    yield put({
      type: typeActions.UPDATE_BILL_FAILED,
      error: error?.response?.data?.error?.message ?? '',
    });
    !!callback?.failed &&
      callback.failed(error?.response?.data?.error?.message ?? '');
  }
}

export function* deleteBill(data) {
  const url = `${ServiceURL.bill}/${data.param}`;
  const callback = data.callback;
  try {
    const res = yield call(DELETE, url);
    if (!!res.data?.error?.message) {
      yield put({
        type: typeActions.DELETE_BILL_FAILED,
        error: res.data.error.message,
      });
      !!callback?.failed && callback.failed(res.data.error.message);
    } else {
      yield put({
        type: typeActions.DELETE_BILL_SUCCESS,
        data: res.data,
      });
      !!callback?.success && callback.success(res.data);
    }
  } catch (error) {
    yield put({
      type: typeActions.DELETE_BILL_FAILED,
      error: error?.response?.data?.error?.message ?? '',
    });
    !!callback?.failed &&
      callback.failed(error?.response?.data?.error?.message ?? '');
  }
}

function* getBillRelation(data) {
  try {
    const callback = data.callback;
    const urlRelation = `${ServiceURL.relation}/api::bill.bill/${data.id}/${data.relationTo}?pageSize=100`;

    const response = yield call(GET, urlRelation);

    const results = _.get(response, 'data.results', []);
    if (results.length === 0) return null;
    switch (data.relationTo) {
      case 'paymentHistories':
        const apis = results.map((item) => {
          const urlPaymentHistory = `${ServiceURL.paymentHistory}/${
            item.id ?? -1
          }`;
          return call(GET, urlPaymentHistory);
        });
        const res = yield all(apis);
        !!callback?.success &&
          callback.success(
            res.map((v) => {
              const r = _.get(v, 'data', {});
              return r;
            })
          );
        break;
      default:
        return null;
    }
  } catch (error) {}
}

export default function* billSaga() {
  yield takeLatest(typeActions.GET_BILLS_REQUEST, getBills);
  yield takeLatest(typeActions.GET_BILL_REQUEST, getBill);
  yield takeLatest(typeActions.GET_BILL_RELATION_REQUEST, getBillRelation);
  yield takeLatest(typeActions.CREATE_BILL_REQUEST, createBill);
  yield takeLatest(typeActions.UPDATE_BILL_REQUEST, updateBill);
  yield takeLatest(typeActions.DELETE_BILL_REQUEST, deleteBill);
}
